import axios from "axios";

const http = axios.create({
  baseURL: "https://opiniongames.net/api/super-admin/",
});

// REQUEST INTERCEPTOR
http.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  // JSON requests
  if (!(config.data instanceof FormData)) {
    config.headers["Content-Type"] = "application/json";
  }

  return config;
});

// RESPONSE INTERCEPTOR
http.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.clear();
      window.location.href = "/sign-in";
    }
    return Promise.reject(err);
  }
);

export default http;
